import { iconSwitchTransition as e } from "./highrise1457.mjs";
import { c as o, cB as r, cE as t } from "./highrise314.mjs";
const n = o([o("@keyframes rotator", `
 0% {
 -webkit-transform: rotate(0deg);
 transform: rotate(0deg);
 }
 100% {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }`), r("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [t("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [e()]), t("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [e({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), t("container", `
 animation: rotator 3s linear infinite both;
 `, [t("icon", `
 height: 1em;
 width: 1em;
 `)])])]);
export {
  n as default
};
